<template>
    <div class="user-wrapper">
        <button class="null" v-if="loggedIn" @click="$refs.userMenu.toggle()">
            <span class="user-name">
                <div class="user-arrow"></div>
                {{ name }}
            </span>
            <img class="user-avatar" :src="avatar">
        </button>
        <div v-else>
            <ul class="login-register">
                <li>
                    <a href="/login" @click.prevent="animateShowModal(showLoginComponent)">Login</a>
                </li>
                <li>
                    <a href="/register" @click.prevent="animateShowModal(showRegisterComponent)">Sign Up</a>
                    <sign-up-prompt></sign-up-prompt>
                </li>
            </ul>
        </div>

        <user-menu v-if="loggedIn" ref="userMenu"></user-menu>

        <modal ref="modal"></modal>
    </div>
</template>

<script>
    import Modal                    from "./Modal";
    import Login                    from "./Login";
    import UserMenu                 from "./UserMenu";
    import Register                 from "./Register";
    import { mapGetters, mapState } from 'vuex';
    import SignUpPrompt             from "../../../../App/Views/Components/SignUpPrompt";

    export default {
        name      : "user-header",
        components: {
            SignUpPrompt,
            Modal,
            Login,
            Register,
            UserMenu,
        },

        computed: {
            ... mapState('User', {
                id  : user => user.id,
                name: user => user.name,
                avatar: user => user.avatar,
            }),
            ...mapGetters({loggedIn: 'User/isLoggedIn'})
        },

        data() {
            return {
                userMenuActive: false,
            }
        },

        methods: {
            animateShowModal(method) {
                method();
                this.$refs.modal.animateModalIn();
            },

            showRegisterComponent() {
                this.$refs.modal.showRegisterComponent()
            },

            showLoginComponent() {
                this.$refs.modal.showLoginComponent()
            },
        },

        mounted() {
            window.Broadcast.$on('user-set', () => this.user = this.$user.user);

        }
    }
</script>
